import styled, { css } from 'styled-components'

import { Option } from 'components/Option'

import { Color, MediaBreakpoint } from 'root-constants'

export const StyledIntroCardsQuestion = {
  Container: styled.div`
    max-width: 375px;
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 24px 24px 0;
    margin: 0 auto;
  `,
  Title: styled.p`
    font-size: 32px;
    font-weight: 700;
    line-height: 36px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    @media (max-width: ${MediaBreakpoint.MIN_PHONE}px) {
      font-size: 28px;
      line-height: 32px;
    }

    margin-bottom: 24px;
  `,
  QuizLabel: styled.p`
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: 24px;
  `,
  Subtitle: styled.p`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    margin-bottom: 48px;
  `,
  Question: styled.p<{ $isAccent?: boolean }>`
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    ${({ $isAccent }) =>
      $isAccent &&
      css`
        font-size: 16px;
        line-height: 24px;
        color: ${Color.GOLD_BASE};
      `}

    margin-bottom: 24px;
  `,
  Options: styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  `,
  Option: styled(Option)<{ $isSmallText?: boolean }>`
    height: 60px;
    display: flex;
    align-items: center;
    gap: 8px;

    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    color: ${Color.INK_DARKER};

    background-color: ${Color.WHITE};
    border-radius: 24px;
    transition:
      background-color 200ms ease-out,
      box-shadow 200ms ease-out;

    padding-block: 4px;
    padding-inline: 25px 16px;

    @media (max-width: ${MediaBreakpoint.MIN_PHONE}px) {
      font-size: 16px;

      padding-inline: 16px 12px;
    }

    ${({ $isSmallText }) =>
      $isSmallText &&
      css`
        font-size: 16px;
        padding-inline: 16px 12px;

        @media (max-width: ${MediaBreakpoint.MEDIUM_PHONE}px) {
          gap: 4px;
          font-size: 14px;
          padding-inline: 12px 8px;
        }
      `}

    ${({ checked }) =>
      checked &&
      css`
        background-color: ${Color.GOLD_LIGHTEST};
        box-shadow: 0 0 0 1.5px ${Color.GOLD_LIGHT};
      `}
  `,
  ArrowCircle: styled.span<{ $isLight: boolean }>`
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${({ $isLight }) => ($isLight ? Color.WHITE : Color.SKY)};
    border-radius: 50%;
    transition: background-color 200ms ease-out;

    margin-inline-start: auto;

    html[dir='rtl'] & {
      transform: scaleX(-1);
    }
  `,
  Terms: styled.div`
    width: 100%;

    padding-top: 32px;
    margin-top: auto;
  `,
  TermsNote: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    padding: 24px 0;
  `,
}
